module.exports = __webpack_public_path__ + "img/vesper.44fbaef1.jpg";